import { FormControlLabel, Checkbox } from "@material-ui/core";
import { Field, FieldProps } from "formik";

interface CheckboxFieldProps {
  name: string;
  label: string;
  labelPlacement?: "top" | "start" | "bottom" | "end";
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const CheckboxField = ({ name, label, labelPlacement = "end", onChange }: CheckboxFieldProps) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <FormControlLabel
          control={
            <Checkbox
              {...field}
              checked={Boolean(field.value)}
              onChange={(event, checked) => {
                if (onChange) {
                  onChange(event, checked);
                } else {
                  form.setFieldValue(name, checked);
                }
              }}
            />
          }
          label={label}
          labelPlacement={labelPlacement || 'end'}
        />
      )}
    </Field>
  );
};

export default CheckboxField;
